export default __webpack_public_path__ + "locales/ru/Ldap.json?hash=913ef4b24f54287fdae87223064f1f79";